import {InfoNodes} from "@cm/template-nodes"
import type {SceneNodes, InterfaceDescriptor} from "@cm/template-nodes"
import type {
    MattressLocalNodesData,
    MattressCutData,
    MattressFocusedComponentInstancePath,
    MattressMeshGeometryParametersData,
    MattressNodePath,
    MattressInfoData,
} from "#mattress/nodes/component/mattress-component-types"
import type {MattressCurveData} from "#mattress/nodes/curve/mattress-curve"
import type {MattressReferenceFrameData} from "#mattress/nodes/reference-frame/mattress-reference-frame"
import type {MattressComponentInterfaceDescriptor} from "#mattress/nodes/component/mattress-component-interface-descriptors"

export interface MattressInfoNode extends InfoNodes.InfoNode {
    readonly type: "Mattress"
    localNodesDataList: MattressLocalNodesData[]
    curvesDataList: MattressCurveData[] | null
    referenceFramesDataList: MattressReferenceFrameData[]
    cutsDataList: MattressCutData[]
    focusedComponentInstancePath: MattressFocusedComponentInstancePath
    focusedComponentInstanceWrappedId: string | null
    meshGeometryParameters: MattressMeshGeometryParametersData
    baseMeshSceneNode: SceneNodes.Mesh | null
    segmentedMeshSceneNode: SceneNodes.Mesh | null
    segmentedMeshMaterialSlotsOwners: {[materialID: number]: MattressNodePath | null} | null
    localSceneNodes: SceneNodes.SceneNode[] | null
    templateDescriptorList: InterfaceDescriptor<unknown>[] | null
    componentDescriptorList: MattressComponentInterfaceDescriptor<unknown>[] | null
    infoDataList: MattressInfoData[] | null
}

export const mattressInfoNode = InfoNodes.defInfoNode<MattressInfoNode>("Mattress")
